<template>
  <div>
    <Top></Top>
    <div class="main">
      <!-- 头部 -->
      <div class="head">
        <div>
          <div class="logo fl">
            <router-link to="/">
              www.rakumart-2c.com
            </router-link>
          </div>
          <h2>支払い画面</h2>
        </div>
      </div>
      <p>
        <span>注文番号:{{ orderPay.orderNumber }}</span>
      </p>
      <div class="payment">
        <div class="title">
          <ul>
            <li @click="isChoose(0)" :class="{ choose: index == 0 }">
              残金支払い
            </li>
            <!-- <li @click="isChoose(1)" :class="{ choose: index == 1 }">
              銀行入金
            </li>
            <li @click="isChoose(2)" :class="{ choose: index == 2 }">PayPal</li> -->
          </ul>
          <!-- 残金 -->
          <div class="content" v-show="index == 0">
            <div class="fl">
              <p>
                見積金額：
                <span>{{ orderPay.orderPrice }}</span> 円
              </p>
              <p>
                支払い額：
                <span>{{ orderPay.orderPrice }}</span>円
              </p>
            </div>
            <div class="fr jine">
              <p>
                残高：
                <span>{{ orderPay.balance }}</span> 円
              </p>
              <p>
                残り：
                <span>{{ orderPay.balance - orderPay.orderPrice }}</span> 円
              </p>
              <a href="javascript:;" @click="Payment">支払い</a>
            </div>
          </div>
          <div class="content" v-show="index == 1">
            <div class="fl">
              <p>
                残高：
                <span>3485</span> 円
              </p>
              <p>
                見積金額：
                <span>0</span>
              </p>
              <p>
                支払い額：
                <span>3485</span>円
              </p>
              <h6 style="margin: 0">
                <input type="checkbox" class="checkbox" v-model="checked" />
                国際送料0円も一緒に入金
              </h6>
              <p>最低入金金額：0円</p>
              <ol>
                <li>
                  <span>入金日</span>
                  <input type="text" v-model="val" />
                </li>
                <li>
                  <span>着金予定日</span>
                  <input type="text" v-model="val" />
                </li>
                <li>
                  <span>入金名義</span>
                  <input type="text" v-model="val" />
                </li>
                <li>
                  <span>入金額</span>
                  <input type="text" v-model="val" />
                </li>
                <li>
                  <span>備考欄</span>
                  <input type="text" v-model="val" />
                </li>
              </ol>
              <a href="javascript:;">確定</a>
            </div>
            <div class="fr img-txt">
              <div class="img" :class="{ isShow: show == 1 }" @click="show = 1">
                <img src="../../assets/img/lu.png" alt />
              </div>
              <div class="txt" v-show="show != 2">
                <p>銀行名:ゆうちょ銀行</p>
                <p>支店名：四〇八支店</p>
                <p>口座番号 5631876</p>
                <p>口座名義：ラクマート（カ</p>
                <p style="margin-top: 20px">
                  ゆうちょ銀行からのお振込
                  <br />14040-56318761
                </p>
              </div>
              <div class="img" style="margin-top: 25px" :class="{ isShow: show == 2 }" @click="show = 2">
                <img src="../../assets/img/netBank.webp" alt />
              </div>
              <div class="txt">
                <p>１、銀行入金する金額を入力してください</p>
                <p>
                  ２、銀行入金額は見積り総額より上回るように入
                  力をお願い致します
                </p>
              </div>
              <img src="../../assets/img/ginko.png" alt />
            </div>
          </div>
          <div class="content" v-show="index == 2">
            <div class="fl">
              <p>
                残高：
                <span>3485</span> 円
              </p>
              <p>
                見積金額：
                <span>0</span>
              </p>
              <p>
                支払い額：
                <span>3485</span>円
              </p>
              <h6 style="margin: 0">
                <input type="checkbox" class="checkbox" v-model="checked" />
                ポイントを使用
                <input type="text" class="input" v-model="val" />
                pt (利用可能ポイント：110pt)
              </h6>
              <h6 style="margin: 0">
                <input type="checkbox" class="checkbox" v-model="checked" />
                国際送料0円も一緒に入金
              </h6>
              <p style="margin-top: 40px">最低入金金額：0円</p>
              <div class="paypal">
                <div class="ipt">
                  <strong>￥</strong>
                  <input type="text" v-model="val" />
                </div>
                <a href="javascript:;">PayPalへ</a>
                <h6>（請求料金：0手数料:4%）</h6>
              </div>
            </div>
            <div class="fr pay">
              <div class="pay-img">
                <img src="../../assets\img\paypal (1).png" alt />
              </div>
              <h6>1、チャージする金額を入力してください。</h6>
              <h6>
                2、チャージ額は見積り総額より上回るように入力をお願い致します。
              </h6>
              <h6>
                3、ペイパル入金の場合、さらに4％手数料が必要になりますので、予めご了承ください。
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Top from "../../components/head/Top";
import Foot from "../../components/foot/Foot";
import { orderPayPreview, orderPay } from "../../api/API/order";
export default {
  data() {
    return {
      index: 0,
      checked: false,
      val: "",
      show: 0,
      token: localStorage.getItem("token"),
      orderPay: {}, // 支付金额
      p: "", // 根据定单号开头字母判断订单配送单
      list: {
        mod: "inc",
        act: "ordersys",
        str: "orderPay",
        ordno: this.$route.query.ordno,
        token: "",
        flag: 2,
        ordsts: 0,
        point: 0,
        fangfa: "",
        pflag: "",
        beikao: "",
        huiru: "",
        kin: "",
        nyukin: "",
      },
    };
  },
  components: {
    Top,
    Foot,
  },
  created() {
    this.orderPayPreview();
  },
  methods: {
    isChoose(i) {
      this.index = i;
    },
    // 获取支付金额
    orderPayPreview() {
      this.p = this.$route.query.ordno.substr(0, 1);
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "orderPayPreview",
        ordno: this.$route.query.ordno,
        token: this.token,
      };
      orderPayPreview(list).then((res) => {
        if (res.code != 1) return;
        this.orderPay = res.data;
        console.log(res.data);
      });
    },
    //  余额支付
    Payment() {
      this.list.ordno = this.$route.query.ordno;
      this.list.token = this.token;
      this.list.kin = this.orderPay.orderPrice;
      this.list.nyukin = this.orderPay.orderPrice;
      if (this.p == "P") {
        this.list.pflag = 2;
      }
      orderPay(this.list).then((res) => {
        if (res.code != 1) return this.$message.error("残高不足");
        this.$router.push({
          path: "/paySucceed",
          query: { orderPrice: this.orderPay.orderPrice, data: res.data },
        });
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.main {
  width: 1200px;
  margin: 0 auto 50px;

  .head {
    margin-top: 20px;
    overflow: hidden;
    margin-bottom: 30px;

    .logo {

      height: 100px;
      margin-bottom: 20px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;

      a {
        color: #f3c622;
        font-size: 30px;
        line-height: 100px;

      }

      img {
        height: 100%;
      }
    }

    h2 {
      float: left;
      font-size: 30px;
      margin: 30px 0 0 40px;
    }
  }

  p {
    font-weight: bold;
    font-size: 20px;
    color: #333;
  }

  .payment {
    margin: 30px auto;
    height: 1200px;
    background: #f7f7f7;
    box-shadow: 0px 3px 5px 0 rgba(0, 0, 0, 0.35);
    border-radius: 15px;

    .title {
      padding: 100px 80px 0;

      ul {
        overflow: hidden;

        li {
          float: left;
          width: 150px;
          height: 60px;
          cursor: pointer;
          text-align: center;
          line-height: 60px;
          font-size: 26px;
          margin-right: 30px;
          background-color: #ccc;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
        }
      }

      .choose {
        background: #f3c622;
      }

      .content {
        border: 3px solid #f3c622;
        padding: 100px 60px;
        overflow: hidden;

        p {
          font-size: 30px;
          margin-bottom: 30px;

          span {
            color: #f3c622;
          }
        }

        h6 {
          width: 237px;
          margin-bottom: 100px;
          font-size: 18px;

          .checkbox {
            width: 20px;
            height: 20px;
          }

          .input {
            width: 40px;
            height: 20px;
          }
        }

        .jine {
          width: 300px;
        }

        a {
          display: block;
          margin-top: 50px;
          width: 100px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          color: #fff;
          background-color: #f3c622;
          font-size: 20px;
          border-radius: 5px;
        }

        ol {
          li {
            height: 30px;
            margin-bottom: 20px;

            span {
              display: inline-block;
              width: 100px;
              font-size: 20px;
            }

            input {
              border: 1px solid #f3c622;
              height: 28px;
              width: 120px;
            }
          }
        }

        .img-txt {
          width: 350px;

          .img {
            width: 170px;
            height: 90px;
            border: 2px solid transparent;

            img {
              width: 170px;
              height: 90px;
            }
          }

          .isShow {
            border: 2px solid #f3c622;
          }

          .txt {
            margin-top: 20px;

            p {
              font-size: 16px;
              margin: 0;
              font-weight: 500;
            }
          }
        }

        .paypal {
          position: relative;
          width: 350px;

          .ipt {
            float: left;
            border: 1px solid #f3c622;
            height: 42px;
            width: 170px;
            margin-left: 40px;

            strong {
              //   display: inline-block;
              float: left;
              height: 35px;
              width: 30px;
              font-size: 20px;
              margin: 3px 10px 0 3px;
              line-height: 35px;
              border-right: 1px solid #f3c622;
              text-align: center;
            }

            input {
              float: left;
              border: 0;
              height: 40px;
              width: 126px;
              font-size: 18px;
              background: transparent;
            }
          }

          a {
            position: absolute;
            top: 0;
            right: 0px;
            margin: 0;
          }
        }

        .pay-img {
          width: 220px;
          height: 116px;
          margin-bottom: 20px;
          margin-left: 40px;

          img {
            width: 220px;
            height: 116px;
          }
        }

        .pay {
          width: 350px;

          h6 {
            width: 350px;
            margin: 0;
          }
        }
      }
    }
  }
}
</style>